import imageToBase64 from 'image-to-base64/browser';
import firebase from "firebase";
import {deleteFileByUrl} from "@/utils/upload-image";
import moment from "moment/moment";
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue';
import VueGoodshareLinkedin from 'vue-goodshare/src/providers/LinkedIn.vue';
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter.vue';

export default {
  name: "GalleryShareDlg",
  components: {
    VueGoodshareFacebook,
    VueGoodshareLinkedin,
    VueGoodshareTwitter,
  },
  data() {
    return {
      addMediaDialog: false,
      currentMedia: "",
      loading: false,
      mediaSrc: null
    }
  },
  props: {
    showOptions: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    open(media) {
      this.addMediaDialog = true;
      this.currentMedia = media;
      this.mediaSrc = media.image ?? media.video
    },
    close() {
      this.loading = false;
      this.addMediaDialog = false;
    },
    async downloadPhoto(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();

        const mimeType = blob.type;

        const extension = mimeType.split('/')[1];
        const isImage = mimeType.startsWith('image');
        const isVideo = mimeType.startsWith('video');

        if (!isImage && !isVideo) {
          console.warn('Файл не є зображенням або відео.');
          return;
        }

        const urlBlob = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = urlBlob;
        a.download = isImage ? `Photo.${extension}` : `Video.${extension}`;
        a.click();

        URL.revokeObjectURL(urlBlob);


        /*const ImageUrl = url;
        const ImageBase64 = await imageToBase64(ImageUrl);
        const a = document.createElement('a');
        a.href = 'data:image/png;base64,' + ImageBase64;
        a.download = 'Photo.png';
        a.click();*/
      } catch (error) {
        console.error(error);
      }
    },
    async deletePhoto(media) {
      this.loading = true;
      const mediaSrc: string = media?.image ?? media?.video;

      await firebase
        .firestore()
        .collection('photos')
        .doc(media.id)
        .delete()
        .then(async () => {
          await deleteFileByUrl(mediaSrc)
            .then(async () => {
              const str = mediaSrc;
              const from = 0;
              const to = str.search('alt') - 1;
              const first = str.substring(from, to) + '_200x200';
              const second = str.substring(to, str.length);
              const url = first + second;
              await deleteFileByUrl(url);
            })
            .catch((error) => {
              this.$toast.open({
                message: this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoCannotBeDeletedMessage'],
                type: 'error',
              });
            });
        })
        .catch(() => {
          this.$toast.open({
            message: this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoCannotBeDeletedMessage'],
            type: 'error',
          });
        });

      await this.$emit('getPhotos', media)

      this.close();

      this.$toast.open({
        message: this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoSuccessfullyDeleted'],
        type: 'success',
      });
    },
    sharePhotoByEmail(media) {
      this.close();
      this.$emit("shareMediaByEmail", media);
    },
  }
}